import { pixelTextWidth } from "../../ui/kit/pixel-text.ts";

/**
 * What a key and a physical key may look like (P1.9-T50, P1.9-T50b; ADR-061's amendments "key rebinding" and "Move
 * joins the key table"): capture and reading ask the same questions, so a key that can be chosen is never dropped on
 * the next load.
 */

/**
 * Whether the pixel face can draw a label, which the key caps in the HUD and the prompt in the world are set in.
 *
 * @param label The label.
 * @returns True when every character has a glyph.
 */
export function drawn(label: string): boolean {
  try {
    pixelTextWidth(label);
    return true;
  } catch {
    return false;
  }
}

/**
 * A physical key's code as browsers write them: a capital, then letters and digits (`IntlBackslash`, `NumpadDecimal`).
 */
const CODE_SHAPE = /^[A-Z][A-Za-z0-9]{1,29}$/;

/**
 * Whether a value has a physical key's shape.
 *
 * @param value The `KeyboardEvent.code` value or the stored text.
 * @returns True for a code's shape.
 */
export function codeShaped(value: string): boolean {
  return CODE_SHAPE.test(value);
}
